import { useCallback } from 'react';
import { useChatContext } from '../../contexts/ChatContext';
import { ClassicMessageEditor, MessageEditorProps } from '../MessageEditor/ClassicMessageEditor';
import { useIsLightChatLayout } from 'hooks/useChatLayoutType';
import { LightMessageEditor } from '../MessageEditor/LightMessageEditor';

interface ChatMessageEditorProps extends Omit<MessageEditorProps, 'onScrollToMessage' | 'onSend'> {
  conversation: Conversation.Conversation;
}

export const ChatMessageEditor = (props: ChatMessageEditorProps) => {
  const { dialogRef } = useChatContext();
  const isLightChatLayout = useIsLightChatLayout();

  const handleScrollToMessage = useCallback(
    (msg: Conversation.Message) => {
      dialogRef?.scrollToMessageByScrollTo(msg.msgId);
    },
    [dialogRef],
  );

  const handleSend = useCallback(() => {
    dialogRef?.scrollTo('bottom');
  }, [dialogRef]);

  if (isLightChatLayout) {
    return (
      <LightMessageEditor
        {...props}
        onScrollToMessage={handleScrollToMessage}
        onSend={handleSend}
      />
    );
  } else {
    return (
      <ClassicMessageEditor
        {...props}
        onScrollToMessage={handleScrollToMessage}
        onSend={handleSend}
      />
    );
  }
};
